import { ScheduleConfig, ScheduleRecord } from "../../documents/Schedule";
import { CoolingModes, HeatingModes, TempControlModes } from "../../../types"
import logger from '../../../utils/Logger';

/**
 * Manipulates passed in config in place
 * @param config
 */
export default function migrateScheduleConfig(config: ScheduleRecord) {
    const schedule = config.data.Schedule;
    schedule?.forEach((itemSchedule) => {
        itemSchedule.ScheduleElements?.forEach(itemScheduleElement => {
            itemScheduleElement?.Times?.forEach(itemTimes => {
                if (itemTimes.ControlMode as string === "SMART") {
                    itemTimes.ControlMode = TempControlModes.AUTO;
                }
                if (itemTimes.HeatingMode as string === "AUTO") {
                    itemTimes.HeatingMode = HeatingModes.SMART;
                }
                if (itemTimes.CoolingMode as string === "AUTO") {
                    itemTimes.CoolingMode = CoolingModes.SMART;
                }
            });
        });
    });
}